import axios from "axios";
import noUiSlider from 'nouislider';
import './assets/css/slider.css';
const { ACTION, ACTION_ADD_TO_CART, PRODUCT_ID, PRODUCT_QUANTITY, LINKS, INITIAL_QUANTITIES, REQUEST_DEFAULT_CONFIG} = require('./parameters/RequestParameters');
const siteURL = window.location.origin;
const apiURL = 'https://api2.comprasocial.me/';
const apiUserEndpoint  = 'ig/user';
const apiMediaEndpoint  = 'ig/media';

axios.defaults.headers = {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  };

export default {
    name: "App",
    components: {},
    data: function() {
        return {
            product: {
                id: '',
                array: null,
                variations: 50,
                selected: {},
                initialUnitPrice: 0,
                initialQuantity: null,
                minQuantity: 50,
                links: [],
                linkDisplay: '',
                htmlClass: 'cs4-productCrossImageWrapper',
                numberOfPosts: 1,
                cross: {
                    id: '',
                    quantities: new Map(),
                    prices: {},
                    quantity: 0,
                    variations: 50,
                    price: 0,
                    selectedId: 0,
                    link: '',
                    isSelected: false,
                }
            },
            input: {
                field: "",
                postUrl: ""
            },
            icons: {
                crystal: 'https://comprasocial.me/wp-content/uploads/2019/07/Crystal@2x.png',
                product: 'https://comprasocial.me/wp-content/uploads/2019/09/icon-like.png',
                crossProduct: 'https://comprasocial.me/wp-content/uploads/2020/10/icon_cuore.svg',
                confirm: 'https://comprasocial.me/wp-content/uploads/2019/09/checked@2x.png'
            },
            steps: {
                isFirst: true,
                isSecond: false,
                isSecondPhotoURL: false,
                isLoading: false,
                isAddingToCart: false,
                orderCompleted: false,
                isCrossProductAdded: false
            },
            user: {
                medias: [],
                isPrivate: false,
                profilePic: '',
                username: '',
                followers: 0
            },
            errors: {
                noMedia: false,
                notFound: false,
            },
            dictionary: {}
        };
    },
    methods: {
        getProductInfo: async function() {
            return axios.get(this.getProductApiURL()).then((res) => {
                this.product.array = res.data.sort(function(product1, product2) {
                    return product1.id < product2.id ? -1 : 1;
                });
            });
        },
        getCrossProductInfo: async function(){
            return axios.get(this.getCrossProductApiURL()).then((res) => {
                this.product.cross.prices = res.data.sort(function(product1, product2) {
                    return product1.id < product2.id ? -1 : 1;
                }).map(product => {
                    return this.mapProduct(product)
                });
            });
        },
        generateStarForReview: function(dictionary) {
            let givenRating = dictionary.reviewValue;
            let resHtml = `<strong>${givenRating}</strong> ${dictionary.on} 5 `;
            for(let count = 0; count < 5; count++) {
              if(givenRating >= 1){
                resHtml += `<img class="cs4-star" src="${dictionary.fullStarIcon}" alt="star">`
              } else if( givenRating >= 0.5 && givenRating < 1) {
                resHtml += `<img class="cs4-star" src="${dictionary.halfStarIcon}" alt="star">`
              } else {
                resHtml += `<img class="cs4-star" src="${dictionary.emptyStarIcon}" alt="star">`
              }
              givenRating--;
            }
            resHtml += `<div class="cs4-review-section__based-on"> ${dictionary.reviewTotalNumber} ${dictionary.reviewTotalLabel}</div> `;
            return resHtml;
        },
        mapProduct(product){
            return {
                id: product.id,
                price: product.price,
                quantity: product.attributes.find(attribute => attribute.name === "Quantità").option
            }
        },
        getProductApiURL: function() {
          return `https://api2.comprasocial.me/products/priceList/${this.product.id}`
        },
        getCrossProductApiURL: function() {
          return `https://api2.comprasocial.me/products/priceList/${this.product.cross.id}`
        },
        getProductQuantity: function(productIndex, cleanFromDots = false) {
            if(productIndex){
                const res = this.product.array[productIndex].attributes.find((el) => el.name == "Like").option;
                return cleanFromDots ? res.replace('.','') : res;
            }
            if(this.product.selected && this.product.selected.attributes){
                const res = this.product.selected.attributes.find((el) => el.name == "Like").option;
                return cleanFromDots ?  res.replace('.','') : res;
            }
            return 0;
        },
        getProductQuantityText: function(){
            if(this.product.numberOfPosts === 1){
                return this.dictionary.toTheLastPublishedPost;
            } else {
                return `${this.dictionary.toTheLast}${this.product.numberOfPosts}${this.dictionary.postPublished}`;
            }
        },
        getProductPrice: function(productIndex){
            if(productIndex){
                const product = this.product.array[productIndex];
                return  product.sale_price ? Number.parseFloat(product.sale_price).toFixed(2) :  Number.parseFloat(product.regular_price).toFixed(2);
            }
            if(this.product.selected && this.product.selected.regular_price) {
                return this.product.selected.sale_price ? Number.parseFloat(this.product.selected.sale_price).toFixed(2) :  Number.parseFloat(this.product.selected.regular_price).toFixed(2);
            }
            return 0.00.toFixed(2)
        },
        getProductCrystal: function(){
            return Math.floor(Number.parseFloat(this.getProductPrice()));
        },
        getProductDiscount: function(){
            const currentProductUnitPrice = this.getProductPrice() / this.getProductQuantity(null, true);
            const decrease = ((this.product.initialUnitPrice - currentProductUnitPrice) / this.product.initialUnitPrice ) * 100;
            return decrease > 0 ? `${this.dictionary.discountText} ${Number.parseInt(decrease)}%` : '';
        },
        setSlider: function(){
            var slider = document.getElementById('cs4-productSlider');
            const likeQuantities = []
            this.product.array.forEach(productElement => {
                const likeQuantity = productElement.attributes.find(el => el.name === "Like").option;
                if(!likeQuantities.includes(likeQuantity)){
                    likeQuantities.push(likeQuantity);
                }
            })
            noUiSlider.create(slider, {
                start: [0],
                range: {
                    'min': 0,
                    'max': likeQuantities.length - 1
                },
                connect: "lower",
                tooltips: {to: (sliderValue) => {
                        const index = Math.round(sliderValue);
                        this.product.selected = this.product.array.find((el) => {
                            return el.attributes[0].option == likeQuantities[index] && el.attributes[1].option == this.product.numberOfPosts;
                        });
                        return `<img class="cs4-product-icon" src="${this.icons.product}"/> +${likeQuantities[index]}`
                    }},
                step: 1
            });
        },
        setNumberOfPosts: function(numberOfPosts){
            this.product.numberOfPosts = numberOfPosts;
            this.product.selected = this.product.selected = this.product.array.find((el) => {
                return el.attributes[0].option == this.getProductQuantity() && el.attributes[1].option == this.product.numberOfPosts;
            });
        },
        cleanInputField() {
            this.input.field = this.input.field.replace(" ",'');
            this.input.field = this.input.field.replace(new RegExp('.*instagram.com/'),'');
            this.input.field = this.input.field.replace(new RegExp("\\?.*"),'')
        },
        isInputFieldAInstagramPhoto(){
            return this.input.field.match(new RegExp('p\\/|reel\\/|tv\\/.'))
        },
        goToSecondStep: function() {
            this.resetUserInfo();
            this.cleanInputField();
            if(this.input.field.replace(" ", "") === "") {
                const inputField = document.getElementById("inputField");
                inputField.classList.add("errorBounce");
                setTimeout(function(){
                    inputField.classList.remove("errorBounce");
                }, 1000)
            } else {
                this.steps.isSecond = false;
                this.steps.isFirst = false;
                this.steps.isLoading = true;
                if (this.isInputFieldAInstagramPhoto()) {
                    this.setPhotoAndUserData(this.input.field.replace('p\\/|reel\\/|tv\\/','').replace('/',''));
                } else {
                    this.setUserData(this.input.field).then(async () => {
                        this.steps.isLoading = false;
                        this.steps.isSecond = true;
                        this.product.links = this.getLastNPostsOfUser();
                        if(!this.user.isPrivate && this.user.medias.length > 0){
                            await this.addProductToCart();
                        }
                    }).catch(async () => {
                        this.steps.isLoading = false;
                        this.product.links = [this.input.field];
                        this.product.initQuantities = ['unavailable']
                        await this.addProductToCart(true);
                    })
                }
            }
            this.setCrossProductQuantity()
        },
        setPhotoAndUserData: async function(photoCode){
            axios.post(apiURL + apiMediaEndpoint,{
                user: photoCode
            }).then(async (res) => {
                if(res.data === {} || res.data.err){
                    this.steps.isLoading = false;
                    this.input.field = this.input.field.replace('p\\/|reel\\/|tv\\/','');
                    this.product.links = [{shortcode: this.input.field}];
                    await this.addProductToCart();
                } else {
                    const result = res.data;
                    this.steps.isLoading = false;
                    this.steps.isSecond = true;
                    this.user.profilePic = result.profilePic;
                    this.user.followers = result.followers;
                    this.user.username = result.username;
                    this.input.field = this.dictionary.instagramPhotoURL + result.shortcode;
                    this.product.links = [{shortcode: result.shortcode, img: result.img, likes: result.likes}];
                    await this.addProductToCart();
                }
            });
        },
        setUserData: async function(username){
            return axios.post(apiURL + apiUserEndpoint,{
                user: username
            }).then(res => {
                this.user = res.data;
            });
        },
        getMediasURLs() {
            return this.product.links.map(item => {
                return `https://www.instagram.com/p/${item.shortcode}`
            })
        },
        getMediaInitialQuantities() {
            return this.product.links.map(item => {
                return item.likes;
            })
        },
        initCrossProduct: function(){
            this.product.cross.quantities.set('500','250');
            this.product.cross.quantities.set('750','250');
            this.product.cross.quantities.set('1000','500');
            this.product.cross.quantities.set('1500','500');
            this.product.cross.quantities.set('2500','750');
            this.product.cross.quantities.set('5000','1.000');
            this.product.cross.quantities.set('7500','1.000');
            this.product.cross.quantities.set('10000','1.000');
        },
        setCrossProductQuantity(){
            this.product.cross.quantity = this.product.cross.quantities.get(this.getProductQuantity(null,true));
            const selectedCrossProduct = this.product.cross.prices.find(crossProduct => crossProduct.quantity === this.product.cross.quantity)
            this.product.cross.price = selectedCrossProduct.price;
            this.product.cross.selectedId = selectedCrossProduct.id;
        },
        getLastNPostsOfUser: function(){
            if(this.user.medias.length <= this.product.numberOfPosts){
                return this.user.medias.slice(0,this.user.medias.legnth);
            }
            return this.user.medias.slice(0,this.product.numberOfPosts);
        },
        goToFirstStep(){
            this.product.selected = {};
            this.product.cross.medias = [];
            this.product.cross.quantity = 0;
            this.product.numberOfPosts = 1;
            this.product.cross.price = 0;
            this.product.initialQuantity = null;
            this.product.cross.initialQuantities = null;
            this.product.cross.isSelected = false;
            this.input.field = "";
            this.input.postUrl = "";
            this.steps.isSecond = false;
            this.steps.isSecondPhotoURL = false;
            this.steps.isAddingToCart = false;
            this.steps.orderCompleted = false;
            this.steps.isFirst = true;
            this.resetUserInfo();
            setTimeout(() => this.setSlider(),100);
        },
        resetUserInfo() {
            this.user = {
                medias: [],
                isPrivate: false,
                profilePic: '',
                username: '',
                followers: 0
            }
        },
        addCrossProductToCart: async function(){
            this.steps.orderCompleted = false;
            this.onToggleProductToCart();
            const crossRequestFormData =  this.createAddToCartRequestBody(this.product.cross.selectedId, this.user.username, parseInt(this.user.followers));
            await this.runAddToCartRequest(crossRequestFormData);
            this.steps.isCrossProductAdded = true;
            this.increaseCartItemCounter();
            this.onToggleProductToCart();
            this.steps.orderCompleted = true;
            this.goToCheckout();
        },
        increaseCartItemCounter() {
            const cartItemCounter = document.getElementById('cs-header__cartCounter');
            cartItemCounter.innerText = parseInt(cartItemCounter.innerText) + 1;
        },
        addProductToCart: async function(usernameNotFound) {
            this.onToggleProductToCart();
            if(this.product.links.length > 0){
                let productRequestFormData;
                if(usernameNotFound){
                    productRequestFormData = this.createAddToCartRequestBody(this.product.selected.id, this.product.links,this.product.initialQuantities);
                } else {
                    productRequestFormData = this.createAddToCartRequestBody(this.product.selected.id, this.getMediasURLs(),this.getMediaInitialQuantities());
                }
                await this.runAddToCartRequest(productRequestFormData)
                this.increaseCartItemCounter();
            }
            this.onToggleProductToCart();
        },
        onToggleProductToCart(){
            if(this.steps.isAddingToCart){
                this.steps.isLoading = false;
                this.steps.isAddingToCart = false;
                this.steps.orderCompleted = true;
            } else {
                this.steps.isLoading = true;
                this.steps.isSecond = false;
                this.steps.isFirst = false;
                this.steps.isSecondPhotoURL = false;
                this.steps.isAddingToCart = true;
            }
        },
        createAddToCartRequestBody(productId, links, initQuantities){
            const formBody = new URLSearchParams();
            formBody.append(ACTION,ACTION_ADD_TO_CART);
            formBody.append(PRODUCT_ID, productId);
            formBody.append(PRODUCT_QUANTITY, 1);
            formBody.append(LINKS, links);
            if(initQuantities !== null){
                formBody.append(INITIAL_QUANTITIES, initQuantities);
            }
            return formBody;
        },
        runAddToCartRequest(requestBody){
            // eslint-disable-next-line no-undef
            return axios.post(wc_add_to_cart_params.ajax_url, requestBody,REQUEST_DEFAULT_CONFIG);
        },
        verifyInputAndAddProductToCart(){
            if(this.input.postUrl.replace(" ", "") === "") {
                const inputField = document.getElementById("postUrl");
                inputField.classList.add("errorBounce");
                setTimeout(function(){
                    inputField.classList.remove("errorBounce");
                }, 1000)
            } else {
                this.input.field = this.input.postUrl;
                this.goToSecondStep();
            }
        },
        continueToBuy(){
            this.goToFirstStep();
        },
        goToCheckout(){
            const cartButton = document.getElementsByClassName('cs-header__cartWrapper')[0];
            cartButton.click();
        }
    },
    mounted: function() {
        this.steps.isFirst = false;
        this.steps.isLoading = true;
        // eslint-disable-next-line no-undef
        axios.get( siteURL + '/wp-content/themes/cs-theme/assets/sliders-dictionaries/instagram/multipost/dictionary-' + currentLanguage + '.json').then(
            res => {
                this.dictionary = res.data;
                this.product.id = this.dictionary.productID;
                this.product.cross.id = this.dictionary.crossProductID;
                this.steps.isFirst = true;
                this.steps.isLoading = false;
                this.getProductInfo().then(() => {
                    this.initCrossProduct();
                    this.setSlider();
                    this.product.initialUnitPrice = this.getProductPrice(0) / this.getProductQuantity(0);
                });
                this.getCrossProductInfo();
            }
        )
    },
};
